__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "opcc-portal-shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@DeepHealth/dhos-common-utils", "1.0.6", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6373))))));
			register("@reduxjs/toolkit", "2.12.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(9879))))));
			register("@tanstack/react-query", "5.101.4", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(8980))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(961))))));
			register("react-error-boundary", "4.1.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(7665))))));
			register("react-redux", "9.3.0", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(1468))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(1715))))));
			register("react", "18.3.1", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(6540))))));
			initExternal(8312);
			initExternal(3499);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};